module.exports = __webpack_public_path__ + "img/empty.1445ac86.png";